var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_vm._t("default",function(){return [_c('div',{staticClass:"content has-text-grey has-text-centered"},[_c('p',[_c('b-icon',{attrs:{"icon":_vm.icon,"pack":_vm.iconPack,"size":"is-large"}})],1),_c('p',[_vm._v(_vm._s(_vm.message))])])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }